import { Injectable, Inject } from '@angular/core';

export class PolicyCovInsuredInsurableDO {
	public id: Number = null;
	public categoryCd: String = null;
	public insurableCd: String = null;
	public insurableValue: DoubleRange = null;
	public appliedForInsurableValue = null;
	public stockCategoryCd: String = null;
}
